//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class PriceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? this.getBaseUrl("");
    }

    /**
     * Creación de un nuevo Precio de descuento
     * @param storeId ID de la tienda
     * @param productId ID del producto
     * @return Precio de descuento creado correctamente
     */
    create(storeId: string, productId: string, body: CreateProductDiscountPriceDto): Observable<void> {
        let url_ = this.baseUrl + "/management/price/store/{storeId}/products/{productId}/discount";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Creación de un nuevo Precio de descuento
     * @param storeId ID de la tienda
     * @param productId ID del producto
     * @param discountPriceId ID del precio de descuento
     * @return Precio de descuento creado correctamente
     */
    delete(storeId: string, productId: string, discountPriceId: string): Observable<void> {
        let url_ = this.baseUrl + "/management/price/store/{storeId}/products/{productId}/discount/{discountPriceId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (discountPriceId === undefined || discountPriceId === null)
            throw new Error("The parameter 'discountPriceId' must be defined.");
        url_ = url_.replace("{discountPriceId}", encodeURIComponent("" + discountPriceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Listar precios activos del producto
     * @param storeId ID de la tienda
     * @param productId ID del producto
     * @param branchId (optional) ID de la sucursal (opcional)
     */
    findActivePrices(storeId: string, productId: string, branchId?: string | undefined): Observable<FindProductPriceResponse[]> {
        let url_ = this.baseUrl + "/management/price/store/{storeId}/products/{productId}/prices?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (branchId === null)
            throw new Error("The parameter 'branchId' cannot be null.");
        else if (branchId !== undefined)
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindActivePrices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindActivePrices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindProductPriceResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindProductPriceResponse[]>;
        }));
    }

    protected processFindActivePrices(response: HttpResponseBase): Observable<FindProductPriceResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FindProductPriceResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Listar historial de precios del producto
     * @param storeId ID de la tienda
     * @param productId ID del producto
     * @param branchId ID de la sucursal
     * @param page (optional) 
     * @param size (optional) 
     * @param sort (optional) 
     */
    findPriceHistory(storeId: string, productId: string, branchId: string, page?: number | undefined, size?: number | undefined, sort?: string | undefined): Observable<FindProductPriceHistoryResponse> {
        let url_ = this.baseUrl + "/management/price/store/{storeId}/products/{productId}/prices/history?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        if (branchId === undefined || branchId === null)
            throw new Error("The parameter 'branchId' must be defined and cannot be null.");
        else
            url_ += "branchId=" + encodeURIComponent("" + branchId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (sort === null)
            throw new Error("The parameter 'sort' cannot be null.");
        else if (sort !== undefined)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindPriceHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindPriceHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FindProductPriceHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FindProductPriceHistoryResponse>;
        }));
    }

    protected processFindPriceHistory(response: HttpResponseBase): Observable<FindProductPriceHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindProductPriceHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid Credentials", status, _responseText, _headers);
            }));
        } else if (![200, 201, 204].includes(status)) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FindProductPriceHistoryResponse>(null as any);
    }

  protected getBaseUrl(defaultUrl: string): string {
    return defaultUrl;
  }
}

export enum DiscountPriceEnum {
    FIXED = "FIXED",
    PERCENTAGE = "PERCENTAGE",
}

export class CreateProductDiscountPriceDto implements ICreateProductDiscountPriceDto {
    /** Enlace permanente */
    code!: string;
    /** Tipo de descuento */
    type!: DiscountPriceEnum;
    /** Valor */
    value!: number;
    /** Branch UUID */
    branchId!: string;
    expiration!: string;


    constructor(data?: ICreateProductDiscountPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.code = _data["code"];
            this.type = _data["type"];
            this.value = _data["value"];
            this.branchId = _data["branchId"];
            this.expiration = _data["expiration"];
        }
    }

    static fromJS(data: any): CreateProductDiscountPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProductDiscountPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["code"] = this.code;
        data["type"] = this.type;
        data["value"] = this.value;
        data["branchId"] = this.branchId;
        data["expiration"] = this.expiration;
        return data;
    }
}

export interface ICreateProductDiscountPriceDto {
    /** Enlace permanente */
    code: string;
    /** Tipo de descuento */
    type: DiscountPriceEnum;
    /** Valor */
    value: number;
    /** Branch UUID */
    branchId: string;
    expiration: string;

}

export class ProductPriceBranchResponse implements IProductPriceBranchResponse {
    id!: string;
    name!: string;


    constructor(data?: IProductPriceBranchResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProductPriceBranchResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPriceBranchResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProductPriceBranchResponse {
    id: string;
    name: string;

}

export class FindProductPriceResponse implements IFindProductPriceResponse {
    priceId!: string;
    branch!: ProductPriceBranchResponse;
    type!: FindProductPriceResponseType;
    quantity!: number;
    amount!: number;
    currency!: FindProductPriceResponseCurrency;
    startDateAt!: string;
    endDateAt?: string;


    constructor(data?: IFindProductPriceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.branch = new ProductPriceBranchResponse();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.priceId = _data["priceId"];
            this.branch = _data["branch"] ? ProductPriceBranchResponse.fromJS(_data["branch"]) : new ProductPriceBranchResponse();
            this.type = _data["type"];
            this.quantity = _data["quantity"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.startDateAt = _data["startDateAt"];
            this.endDateAt = _data["endDateAt"];
        }
    }

    static fromJS(data: any): FindProductPriceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindProductPriceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["priceId"] = this.priceId;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["quantity"] = this.quantity;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["startDateAt"] = this.startDateAt;
        data["endDateAt"] = this.endDateAt;
        return data;
    }
}

export interface IFindProductPriceResponse {
    priceId: string;
    branch: ProductPriceBranchResponse;
    type: FindProductPriceResponseType;
    quantity: number;
    amount: number;
    currency: FindProductPriceResponseCurrency;
    startDateAt: string;
    endDateAt?: string;

}

export class FindProductPriceHistoryResponse implements IFindProductPriceHistoryResponse {
    content!: FindProductPriceResponse[];
    totalElements!: number;
    totalPages!: number;
    size!: number;
    number!: number;
    numberOfElements!: number;
    first!: boolean;
    last!: boolean;
    empty!: boolean;


    constructor(data?: IFindProductPriceHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.content = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(FindProductPriceResponse.fromJS(item));
            }
            this.totalElements = _data["totalElements"];
            this.totalPages = _data["totalPages"];
            this.size = _data["size"];
            this.number = _data["number"];
            this.numberOfElements = _data["numberOfElements"];
            this.first = _data["first"];
            this.last = _data["last"];
            this.empty = _data["empty"];
        }
    }

    static fromJS(data: any): FindProductPriceHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindProductPriceHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item ? item.toJSON() : <any>undefined);
        }
        data["totalElements"] = this.totalElements;
        data["totalPages"] = this.totalPages;
        data["size"] = this.size;
        data["number"] = this.number;
        data["numberOfElements"] = this.numberOfElements;
        data["first"] = this.first;
        data["last"] = this.last;
        data["empty"] = this.empty;
        return data;
    }
}

export interface IFindProductPriceHistoryResponse {
    content: FindProductPriceResponse[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    numberOfElements: number;
    first: boolean;
    last: boolean;
    empty: boolean;

}

export enum FindProductPriceResponseType {
    REGULAR = "REGULAR",
    PROMO = "PROMO",
    BULK = "BULK",
}

export enum FindProductPriceResponseCurrency {
    PEN = "PEN",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}